// Centralized image configuration for Bati Rui
// Replace these URLs with your own images when ready

const IMAGES = {
  // Hero
  "renovation-entree-escalier-helicoidal": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/6vuwigzv_renovation-entree-escalier-helicoidal-carrelage-ciment-paris.jpg",
    alt: "Hall entrée escalier hélicoïdal carrelage ciment floral maison Paris par Bati Rui"
  },

  // Accueil - Réalisations aperçu
  "salle-de-bain-carrelage-chevron": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/b3cfqwhd_salle-de-bain-carrelage-chevron-douche-italienne-paris.jpg",
    alt: "Rénovation salle de bain carrelage chevron noir meuble navy miroir doré douche italienne Paris par Bati Rui"
  },
  "verriere-atelier-bureaux": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/wbey16x9_verriere-atelier-bureaux-parquet-point-hongrie-paris.jpg",
    alt: "Verrière atelier noire mur rouge parquet point de Hongrie bureaux Paris par Bati Rui"
  },
  "creation-mezzanine-escalier-bois": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/cwwo7cxn_creation-mezzanine-escalier-bois-appartement-paris.jpg",
    alt: "Création mezzanine escalier bois garde-corps blanc appartement Paris par Bati Rui"
  },

  // Services
  "renovation-couloir-appartement": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/zgum4czw_renovation-couloir-appartement-paris.jpg",
    alt: "Rénovation couloir appartement peinture grise éclairage encastré parquet chêne Paris par Bati Rui"
  },
  "amenagement-bureaux-verriere": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/tgvdxyp1_amenagement-bureaux-verriere-parquet-point-hongrie-paris.jpg",
    alt: "Aménagement open space bureaux verrière atelier mur rouge parquet point de Hongrie Paris par Bati Rui"
  },
  "pose-mosaique-douche-italienne": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/a5hj8k10_pose-mosaique-douche-italienne-paris.jpg",
    alt: "Pose mosaïque beige douche italienne pommeau encastré robinetterie chromée Paris par Bati Rui"
  },
  "cuisine-equipee-carrelage-ciment": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/5emticsh_cuisine-equipee-carrelage-ciment-meubles-noirs-paris.jpg",
    alt: "Cuisine équipée meubles laqués noirs plan de travail marbre carrelage ciment géométrique Paris par Bati Rui"
  },
  "bibliotheque-sur-mesure-bois": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/kwg17c28_bibliotheque-sur-mesure-bois-polycarbonate-paris.jpg",
    alt: "Bibliothèque sur mesure bois naturel fond polycarbonate cannelé portes laquées bleu Paris par Bati Rui"
  },
  "placards-suspendus-mur-accent-bleu": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/9870c9b9_placards-suspendus-mur-accent-bleu-paris.jpg",
    alt: "Placards suspendus laqués blanc mur accent bleu pétrole appartement Paris par Bati Rui"
  },

  // Réalisations (gallery)
  "cuisine-vert-sauge-terrazzo": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/9d5rwc8e_cuisine-vert-sauge-terrazzo-appartement-haussmannien-paris.jpg",
    alt: "Cuisine vert sauge poignées dorées crédence chevron sol terrazzo appartement haussmannien Paris par Bati Rui"
  },
  "renovation-duplex-cuisine-integree": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/g2t3drre_renovation-duplex-cuisine-integree-garde-corps-paris.jpg",
    alt: "Rénovation duplex cuisine intégrée bois blanc garde-corps bleu canard Paris par Bati Rui"
  },
  "cuisine-meubles-vert-sauge-credence": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/vmhvz9m9_cuisine-meubles-vert-sauge-credence-chevron-terrazzo-paris.jpg",
    alt: "Cuisine meubles vert sauge crédence carrelage chevron blanc sol terrazzo Paris par Bati Rui"
  },
  "detail-main-courante-chene": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/57vx2fjo_detail-main-courante-chene-carrelage-ciment-paris.jpg",
    alt: "Détail main courante chêne massif palier carrelage ciment floral escalier Paris par Bati Rui"
  },
  "renovation-cuisine-ouverte": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/9ufexwza_renovation-cuisine-ouverte-appartement-paris.jpg",
    alt: "Cuisine ouverte bar bois suspensions porte haussmannienne bleu appartement Paris par Bati Rui"
  },
  "amenagement-bureau-integre-duplex": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/vx709mix_amenagement-bureau-integre-duplex-paris.jpg",
    alt: "Aménagement bureau intégré sur mesure étagères bleu canard plan de travail Paris par Bati Rui"
  },
  "couloir-parquet-chevron": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/leivmdbi_couloir-parquet-chevron-renovation-appartement-paris.jpg",
    alt: "Couloir rénové parquet chevron appliques laiton vue sur cuisine bleu canard Paris par Bati Rui"
  },
  "pose-porte-interieure-chene": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/ywc40e4b_pose-porte-interieure-chene-peinture-bleu-parquet-paris.jpg",
    alt: "Pose porte intérieure chêne peinture bleu ardoise parquet clair appartement Paris par Bati Rui"
  },
  "amenagement-entree-banc-integre": {
    url: "https://customer-assets.emergentagent.com/job_bati-rui-preview/artifacts/add22o6u_amenagement-entree-banc-integre-vert-sauge-paris.jpg",
    alt: "Aménagement entrée placards laqués vert sauge banc intégré appartement Paris par Bati Rui"
  },
};

export default IMAGES;
